<template>
	<div class="app-distribution-bar">
		<span :style="candleStyle" class="app-distribution-bar__candle">
			<span :style="innerSpanStyle"/>
		</span>
	</div>
</template>
<script>
export default {
	data() {
		return {
			candleStyle: {},
			tweenedValue: 0,
		};
	},
	computed: {
		color() {
			var percentColors = [
				{pct: 0.0, color: {r: 0x49, g: 0x7D, b: 0xB2}},
				{pct: 100, color: {r: 0xD3, g: 0x50, b: 0x98}}];

			for (var i = 1; i < percentColors.length - 1; i++) {
				if (this.tweenedValue < percentColors[i].pct) {
					break;
				}
			}
			var lower = percentColors[i - 1];
			var upper = percentColors[i];
			var range = upper.pct - lower.pct;
			var rangePct = (this.tweenedValue - lower.pct) / range;
			var pctLower = 1 - rangePct;
			var pctUpper = rangePct;
			var color = {
				r: Math.floor(lower.color.r * pctLower + upper.color.r * pctUpper),
				g: Math.floor(lower.color.g * pctLower + upper.color.g * pctUpper),
				b: Math.floor(lower.color.b * pctLower + upper.color.b * pctUpper),
			};
			return "rgb(" + [color.r, color.g, color.b].join(",") + ")";
		},
		innerSpanStyle() {
			return {
				backgroundColor: this.color,
			};
		},
		// candleStyle() {
		// 	return {
		// 		display: this.data.percent.percent === 0 ? "none" : "block",
		// 		right: this.data.end.withSymbol,
		// 		left: this.data.start.withSymbol,
		// 		width: this.data.percent.withSymbol,
		// 		opacity: 1,
		// 	};
		// },
	},
	props: {
		data: {
			required: true,
			type: Object,
		},
	},
	methods: {
		tween(start, end) {
			let frameHandler;

			// Handles updating the tween on each frame.
			const animate = function (currentTime) {
				window.tween.update(currentTime);
				frameHandler = requestAnimationFrame(animate);
			};

			const myTween = new window.tween.Tween({tweeningValue: start})
				.to({tweeningValue: end}, 750)
				.easing(window.tween.Easing.Quintic.Out)
				// Be careful to not to do too much here! It will slow down the app.
				.onUpdate((tween) => {
					this.tweenedValue = tween.tweeningValue;
					// this.candleStyle.color = this.color;
					// this.tweenedValue = tween.tweeningValue.toFixed(this.round);
					// if (this.round) {
					// 	let parts = this.tweenedValue.split(".");
					// 	let decimal = parseInt(parts[1]);
					// 	if (!decimal) {
					// 		this.tweenedValue = parseInt(parts[0]);
					// 	}
					// }
					// this.animatePaths();
				})
				.onComplete(() => {
					// Make sure to clean up after ourselves.
					cancelAnimationFrame(frameHandler);
				})
				// This actually starts the tween.
				.start();

			frameHandler = requestAnimationFrame(animate);
		},
	},
	mounted() {
		setTimeout(() => {
			this.tween(0, this.data.percent.percent || 0);
			this.candleStyle = {
				display: this.data.percent.percent === 0 ? "none" : "block",
				right: this.data.end.withSymbol,
				left: this.data.start.withSymbol,
				width: this.data.percent.withSymbol,
				opacity: 1,
			};
		}, 500);
	},
};
</script>
